import { render, staticRenderFns } from "./CancellationRequests.vue?vue&type=template&id=02cd0eb0&scoped=true&"
import script from "./CancellationRequests.vue?vue&type=script&lang=js&"
export * from "./CancellationRequests.vue?vue&type=script&lang=js&"
import style0 from "./CancellationRequests.vue?vue&type=style&index=0&id=02cd0eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cd0eb0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
